import { Component, OnInit } from '@angular/core';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { GLOBAL } from 'src/app/services/global';
@Component({
  selector: 'page-formulario19',
  templateUrl: './formulario19.component.html',
  styleUrls: ['./formulario19.component.css']
})
export class Formulario19Component implements OnInit {
  htmlcanvas: any = html2canvas;
  public nombreMuni = GLOBAL.nombreMuni;
  public region = GLOBAL.region;
  public tipo_solicitud;
  public cip;
  public registro_bienes;
  public propiedad;
  public declaracion;
  public propietarios;
  public representantes;
  public permiso_notariado;
  public empresas;
  public arquitectos;
  public constructores;
  public constructora;
  public antecedentes_edif;
  public superficie;
  public unidades;
  public permisos_recep;
  public clasificacion;
  public disposicion;
  public probando_archivos;
 

  //listas filtros

  public perm = [];
  public recep = [];

   pages = [1,2,3];

  constructor() {
 
    this.probando_archivos = {
      "name": "1.9",
      "archivos": [
        { "name": "Listado de documentos y planos numerados", "obligatorio": true, "ready": false },
        { "name": "Informe del Arquitecto que certifique forma en que la edificación a regularizar cumple con las normas técnicas de habilitabilidad y seguridad, con las normas técnicas de estabilidad y con las de instalaciones interiores de electricidad, y cuando corresponda, de agua potable, alcantarillado y gas, establecidas por los Organismos competentes.", "obligatorio": true, "ready": false },
        { "name": "Fotocopia Certificado de Informaciones Previas", "obligatorio": true, "ready": false },
        { "name": "Croquis de emplazamiento a escala, en que se grafique edificación a regularizar; en caso de ampliación graficar además edificación que cuenta con permiso y recepción", "obligatorio": true, "ready": false },
        { "name": "Plano de planta general y elevaciones a escala 1:50 con cotas, individualización de recintos y cuadro de superficies.", "obligatorio": true, "ready": false },
        { "name": "Especificaciones Técnicas resumidas señalando las partidas más relevantes de la edificación.", "obligatorio": true, "ready": false },
        { "name": "Solicitud de Regularización de Obra Menor (Permiso y recepción definitiva Edificación Antigua de cualquier destino (construida con anterioridad al 31/07/1959) Firmada y Escaneada", "obligatorio": true, "ready": false }
      ]
    }


    localStorage.setItem("archivos_antecedentes", JSON.stringify(this.probando_archivos))
    

    //PERMISOS RECEPCION
    if (JSON.parse(localStorage.getItem("permisos_recep")).length > 0){
      this.permisos_recep = JSON.parse(localStorage.getItem("permisos_recep"))
    } else { 
      localStorage.setItem("permisos_recep", JSON.stringify([]))
      this.permisos_recep = [{tipo_permiso:'',permiso:'',numero:null,fecha:null,superficie:null,recepcion:'',fecha_recep:null }]
    }


  if(this.permisos_recep.length > 0){
    for (let i = 0; i < this.permisos_recep.length; i++) {
      
      if(this.permisos_recep[i].tipo_permiso == "Permiso Primitivo"){
        this.perm.push(this.permisos_recep[i]);
        
      }
      
      else if(this.perm.length == 0 && this.permisos_recep.length == (i+1)){
        this.perm = [{tipo_permiso:'',permiso:'',numero:null,fecha:null,superficie:null,recepcion:'',fecha_recep:null }]
                  
      }
      if(this.permisos_recep[i].tipo_permiso == "Ampliaciones"){
        this.recep.push(this.permisos_recep[i]);
      }
      else if( this.recep.length == 0 && this.permisos_recep.length == (i+1)){
        this.recep =  [{tipo_permiso:'',permiso:'',numero:null,fecha:null,superficie:null,recepcion:'',fecha_recep:null },
                      {tipo_permiso:'',permiso:'',numero:null,fecha:null,superficie:null,recepcion:'',fecha_recep:null }];

      }
    }
    if(this.recep.length > 0 && this.recep.length < 5){
      for (let x = this.recep.length ; x < 2; x++) {
        this.recep.push({tipo_permiso:'',permiso:'',numero:null,fecha:null,superficie:null,recepcion:'',fecha_recep:null })
      }
    }
  }
  else{
    this.perm = [{tipo_permiso:'',permiso:'',numero:null,fecha:null,superficie:null,recepcion:'',fecha_recep:null }];
    this.recep =  [{tipo_permiso:'',permiso:'',numero:null,fecha:null,superficie:null,recepcion:'',fecha_recep:null },
                  {tipo_permiso:'',permiso:'',numero:null,fecha:null,superficie:null,recepcion:'',fecha_recep:null }]


  }
}

   ngOnInit(){

   }

   
   ngAfterContentChecked(){
    this.ngAfterContentInit();
  }

   ngAfterContentInit() {

    //CIP
    if(JSON.parse(localStorage.getItem("cip"))){
      if (JSON.parse(localStorage.getItem("cip")).length > 0){ 
        this.cip = JSON.parse(localStorage.getItem("cip"));
      }else{
        localStorage.setItem("cip", JSON.stringify([]))
        this.cip = [{certcip: '' ,fecha_cip: null}]
      }
    }
    
    //REGISTRO
    if(JSON.parse(localStorage.getItem("registro_bienes"))){
      if (JSON.parse(localStorage.getItem("registro_bienes")).length > 0){ 
        this.registro_bienes = JSON.parse(localStorage.getItem("registro_bienes"));
      }else{
       localStorage.setItem("registro_bienes", JSON.stringify([]))
        this.registro_bienes = [{inscrito: '', numero: '', anio: '', bienes: ''}]
      }
    }

    //PROPIEDAD
    if(JSON.parse(localStorage.getItem("propiedad"))){
      if (JSON.parse(localStorage.getItem("propiedad")).length > 0){ 
        this.propiedad = JSON.parse(localStorage.getItem("propiedad"));
      }else{
       localStorage.setItem("propiedad", JSON.stringify([]))
        this.propiedad = [{rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa:'', direc_complemento:'', direc_compl_num:'', loteo:'', manzana:'', plano:'', recordId:''}]
      }
    }

    //PROPIETARIOS
    if(JSON.parse(localStorage.getItem("propietarios"))){
      if (JSON.parse(localStorage.getItem("propietarios")).length > 0){
        this.propietarios = JSON.parse(localStorage.getItem("propietarios"));
      }else{
          localStorage.setItem("propietarios", JSON.stringify([]))
          this.propietarios = [{rut: '', nombre: '',  apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '',  comuna: '', fono: '', fax: '', mail: '',recordId: ''}]
     }
    }
    
     //REPRESENTANTE
     if(JSON.parse(localStorage.getItem("representantes"))){
      if (JSON.parse(localStorage.getItem("representantes")).length > 0){ 
        this.representantes = JSON.parse(localStorage.getItem("representantes")); //no es obligatorio pero si tiene informacion debe estar permiso_notariado obligatoriamente
      }else{
        localStorage.setItem("representantes", JSON.stringify([]))
        this.representantes = [{rut: '', nombre: '',  apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '',  comuna: '', fono: '', fax: '', mail: '',recordId: ''}]
      }
     }

    //Permiso Notariado
    if(JSON.parse(localStorage.getItem("permiso_notariado"))){
      if (JSON.parse(localStorage.getItem("permiso_notariado")).length > 0){
        this.permiso_notariado = JSON.parse(localStorage.getItem("permiso_notariado"));
      }else{
       localStorage.setItem("permiso_notariado", JSON.stringify([]))
        this.permiso_notariado = [{acreditacion:'', fecha:null, escritura:null, notario:''}]
      }
    }
    
    //EMPRESAS
    if(JSON.parse(localStorage.getItem("empresas"))){
      if (JSON.parse(localStorage.getItem("empresas")).length > 0){
        this.empresas = JSON.parse(localStorage.getItem("empresas"))
      } else {
        localStorage.setItem("empresas", JSON.stringify([]))
        this.empresas = [{rut: '',nombre:'', direccion: '', direccion_num:'', direccion_complemento:'', direccion_completa:'',comuna:'',fono:'', fax:'', mail:'', recordId:''}]
      }
    }
    

    //ARQUITECTOS
    if(JSON.parse(localStorage.getItem("arquitectos"))){
      if (JSON.parse(localStorage.getItem("arquitectos")).length > 0){
        this.arquitectos = JSON.parse(localStorage.getItem("arquitectos"))
      }else{ 
       localStorage.setItem("arquitectos", JSON.stringify([]))
        this.arquitectos = [{rut: '', nombre:'', mail:'', apellido_mat:'', apellido_pat:'', direccion: '', direccion_complemento:'', direccion_num:'', comuna:'', fono:'', fax:'',  patente:'', recordId:''}]
      }
    }
    
    //CONSTRUCTORA
    if(JSON.parse(localStorage.getItem("constructora"))){
      if (JSON.parse(localStorage.getItem("constructora")).length > 0){
        this.constructora = JSON.parse(localStorage.getItem("constructora"))
      }else{ 
        localStorage.setItem("constructora", JSON.stringify([]))
          this.constructora = [{rut: '', nombre:'', direccion: '', direccion_num:'', direccion_complemento:'', direccion_completa:'', comuna:'', fono:'', fax:'', mail:'', patente:'', recordId:''}]
      }
    }
    
    //CONSTRUCTORES 
    if(JSON.parse(localStorage.getItem("constructores"))){
      if (JSON.parse(localStorage.getItem("constructores")).length > 0){
        this.constructores = JSON.parse(localStorage.getItem("constructores"))
      }else{ 
        localStorage.setItem("constructores", JSON.stringify([]))
        this.constructores = [{rut: '', nombre:'', mail:'', apellido_mat:'', apellido_pat:'', direccion: '', direccion_complemento:'', direccion_num:'', comuna:'', fono:'', fax:'', patente:'', recordId:''}]
      }
    }
    
    
    //ANTECEDENTES EDIF
    if(JSON.parse(localStorage.getItem("antecedentes_edif"))){
      if (JSON.parse(localStorage.getItem("antecedentes_edif")).length > 0){
        this.antecedentes_edif= JSON.parse(localStorage.getItem("antecedentes_edif"))
      } else { 
        localStorage.setItem("antecedentes_edif", JSON.stringify([]))
        this.antecedentes_edif = [{edificacion_antigua:'',ampliacion_antigua:'',destino:'',superf_total:0,superf_terreno:0,npisos:0}]
      }
    }
    //SUPERFICIE
    if(JSON.parse(localStorage.getItem("superficie"))){
      if (JSON.parse(localStorage.getItem("superficie")).length > 0){ 
        this.superficie = JSON.parse(localStorage.getItem("superficie"))
      } else { 
        localStorage.setItem("superficie", JSON.stringify([]))
        this.superficie = [{util1:'',comun1:'',total1:'',util2:'',comun2:'',total2:'',util3:'',comun3:'',total3:'',piso1:'',piso2:'',piso3:'',piso4:'',piso5:'',piso6:'',piso7:'',piso8:'',piso9:'',piso10:'',piso11:'',piso12:'',piso13:'',piso14:'',piso15:''}] 
      }
    }

    //UNIDADES
    if(JSON.parse(localStorage.getItem("unidades"))){
      if (JSON.parse(localStorage.getItem("unidades")).length > 0){
        this.unidades = JSON.parse(localStorage.getItem("unidades"))
      } else { 
       localStorage.setItem("unidades", JSON.stringify([]))
        this.unidades = [{vivienda:'', oficinas:'', locales:'', estacionamientos:'', otros:''}]
       }
    }
    
     //PERMISOS RECEPCION
    if(JSON.parse(localStorage.getItem("permisos_recep"))){
      if (JSON.parse(localStorage.getItem("permisos_recep")).length > 0){
        this.permisos_recep = JSON.parse(localStorage.getItem("permisos_recep"))
      } else { 
        localStorage.setItem("permisos_recep", JSON.stringify([]))
        this.permisos_recep = [{tipo_permiso:'',permiso:'',numero:0,fecha:null,superficie:0,recepcion:'',fecha_recep:null }]
      }
    }

    //DISPOSICION
    if(JSON.parse(localStorage.getItem("disposicion"))){
      if (JSON.parse(localStorage.getItem("disposicion")).length > 0){
        this.disposicion = JSON.parse(localStorage.getItem("disposicion"))
      } else { 
       localStorage.setItem("disposicion", JSON.stringify([]))
        this.disposicion = [{disposicion1:'',disposicion2:'',disposicion3:'',disposicion4:''}]
      }
    }

    //CLASIFICACION
    if(JSON.parse(localStorage.getItem("clasificacion"))){
      if (JSON.parse(localStorage.getItem("clasificacion")).length > 0){
        this.clasificacion = JSON.parse(localStorage.getItem("clasificacion"))
      } else { 
        localStorage.setItem("clasificacion", JSON.stringify([]))
        this.clasificacion = [{clasificacion:'',metro:''}]
      }
    }
    
  }

  captureScreen(){
    var pdf = new jspdf('p', 'mm', 'a4');

    this.htmlcanvas(document.getElementById(`page1`)).then(canvas => {
       const contentDataURL = canvas.toDataURL('image/png')
       pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297)      
    });

    this.htmlcanvas(document.getElementById(`page2`)).then(canvas => {
      const contentDataURL = canvas.toDataURL('image/png')
      pdf.addPage();
      pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297)      
    });
    this.htmlcanvas(document.getElementById(`page3`)).then(canvas => {
      const contentDataURL = canvas.toDataURL('image/png')
      pdf.addPage();
      pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297)  
    });

    setTimeout(() =>{
      pdf.save(this.propietarios[0].rut+'.pdf')
     // pdf.save('prueba.pdf')
    },6000)
   }

   check_event(event) {
    var igual = false
    for (let i = 0; i < this.probando_archivos.archivos.length; i++) {
      if (this.probando_archivos.archivos[i].name == event.target.defaultValue) {
        igual = true
        if (!event.target.checked) {
          this.probando_archivos.archivos.splice(i, 1)
        }
      }
    }
    if (!igual) {
      this.probando_archivos.archivos.push({ "name": event.target.defaultValue, "obligatorio": true, "ready": false })
    }
    localStorage.setItem("archivos2",  JSON.stringify(this.probando_archivos))


    localStorage.setItem("docs_checkedOK", "cambiado")
    localStorage.setItem("docs_checked", JSON.stringify(this.probando_archivos))
  }
}

